import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip } from 'antd';
import { intialPaginationState, showingPageTotalRange, filter, unexpectedError } from '../../common_functions';

const Authenticitys = props => {
  const [Authenticity, setAuthenticity] = useState([]);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState(intialPaginationState);
  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'Authenticity Confidence',
      dataIndex: 'confidence',
      key: 'confidence',
      sorter: true,
      ...filter('confidence'),
    },
    {
      title: 'Value',
      dataIndex: 'value',
      key: 'value',
      sorter: true,
      ...filter('value'),
    },
    {
      title: 'Description',
      dataIndex: 'desc',
      key: 'desc',
      sorter: true,
      ...filter('desc'),
    },

    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={'/settings/authenticity/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.settings_authenticity?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.settings_authenticity?.edit ? <FormOutlined /> : <EyeOutlined />}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(
              props,
              record.id,
              'authenticity_confidence',
              'Authenticity confidence?',
              Authenticity,
              setAuthenticity,
              props?.tabs_permissions?.settings_authenticity?.delete
            )}
          </div>
        </span>
      ),
    },
  ];
  useEffect(() => {
    (async () => {
    await getAuthenticities(pagination);
  })();
  }, []);

  const getAuthenticities = async (pagination, filters = {}, sorter = '') => {
    try {
      setLoading(true);
      const response = await props.getItems('authenticity_confidence', {
        fields: ['id,confidence,value,desc'],
        sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        filters: filters,
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });
      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setAuthenticity(response.data);
    } catch (error) {
      console.log(error);
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  let handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);
    let filtersitems = {};
    for (let key in filters) {
      if (filters.hasOwnProperty(key)) {
        let val = filters[key];
        if (val) {
          filtersitems[key] = key === 'value' ? { _eq: val[0] } : { _icontains: val[0] };
        }
      }
    }
    await getAuthenticities(pagination, filtersitems, sorter);
  };
  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Settings", href: "/settings/authenticity" }, { title: "Authenticity Confidence" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                View Authenticity Confidence
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(
                props.roleType,
                props.tabs_permissions.settings_authenticity,
                '/settings/authenticity/new',
                'Add New Authenticity Confidence'
              )}
            </Col>
          </Row>
          <hr />
          <div className="artist-list">
            <Table
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              rowKey={record => record.id}
              dataSource={Authenticity}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default Authenticitys;
